import { SimpleForm } from 'react-admin';
import FormContent from './FormContent';
import { AdverseEditDisputeProps } from './types';

const AdverseEditDispute = (props: AdverseEditDisputeProps) => {
  return (
    /* record={{}} sets a clean form --> right way of setting empty default values */
    <SimpleForm mode="onChange" reValidateMode="onChange" record={{}} toolbar={false}>
      <FormContent {...props} />
    </SimpleForm>
  );
};

export default AdverseEditDispute;
